
require("./../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import { GetServerSideProps } from 'next';
import React from 'react';

import {
  ContentLayout,
  getBasicPageContentServerProps,
  parseBasicPageContent,
  parseSeoMetadata,
} from '../common/basicContent';

const BASE_ROUTE = 'business';

type Props = {
  content: string; // JSON string value
};

const BusinessPage: React.FC<Props> = ({ content }: Props) => {
  return (
    <>
      {parseSeoMetadata(content)}
      {parseBasicPageContent(content, ContentLayout.Business)}
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async context => {
  return await getBasicPageContentServerProps(context, BASE_ROUTE);
};

export default BusinessPage;
